import { useLayoutEffect } from "react";

const Section = ({children}) => {
    return <div>{children}</div>;
}
export default Section;